export default {
  getSchedules(state) {
    return state.schedules;
  },
  getTasks(state) {
    return state.tasks;
  }
};
